import { Link } from 'react-router-dom';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="state">
      <div className="err-title">Página não encontrada</div>
      <p>O endereço que você acessou não existe neste guia.</p>
      <Link className="btn" to="/">
        Voltar ao início
      </Link>
    </div>
  );
}
